export function isTimeInvalid(time) {
  const currentTime = new Date()
  const inputTime = new Date(time)
  return currentTime.getTime() > inputTime.getTime()
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/timeUtils.js